import offerRoutes from '@/features/offers/routes'
import applicationRoutes from '@/features/applications/routes'
import HomePage from '@/components/Page/HomePage'
import AccessDeniedPage from '@/components/Page/AccessDeniedPage'
import DashboardPage from '@/components/Page/DashboardPage'
import userRoutes from '@/features/users/routes'

import AuthMiddleware from '../middlewares/AuthMiddleware'

import { UserRole } from '@/features/users/constants'
import OfferRouteWrapper from '@/features/offers/routes/OfferRouteWrapper'
import { Outlet } from 'react-router-dom'
const InternalUserRoutes = [
  {
    breadcrumb: 'Home',
    path: 'home',
    element: <HomePage />,
  },
  {
    breadcrumb: 'User',
    path: 'users',
    children: userRoutes,
  },
  {
    breadcrumb: 'Error',
    path: 'accessDenied',
    element: <AccessDeniedPage />,
  },
  {
    breadcrumb: 'Dashboard',
    path:'dashboard',
    element:<DashboardPage/>
  },
  {
    breadcrumb: 'Offer',
    path: 'offers',
    element: (
      <AuthMiddleware userRoles={[UserRole.ADMIN, UserRole.USER]}>
        <OfferRouteWrapper>
          <Outlet />
        </OfferRouteWrapper>
      </AuthMiddleware>
    ),

    children: offerRoutes,
  },
  {
    breadcrumb: 'Application',
    path: 'applications',
    element: (
      <AuthMiddleware userRoles={[UserRole.ADMIN, UserRole.USER]}>
        <Outlet />
      </AuthMiddleware>
    ),
    children: applicationRoutes,
  },
]

export default InternalUserRoutes
